import appStore from "store/index";

import { isArray, isString } from "lodash";

import {
  userModuleRoutes,
  userPageAccess,
  trainerModuleRoutes,
} from "assets/pageAccess";
// storage
import { lStorage } from "utils/storage";

export const userTypeHasAccess = (routeURL) => {
  let url,
    hasAccess,
    userPageAccessList,
    userTypeList,
    routes = [];

  const { user_type, role } = appStore.getState().loginDetails.login;

  if (isString(routeURL) && routeURL !== "/") {
    url = routeURL.replace(/^\/|\/$/g, "");
  } else {
    url = routeURL;
  }

  userTypeList = userPageAccess.filter((item) => {
    return item.userType === user_type;
  });

  if (userTypeList && isArray(userTypeList) && userTypeList[0]) {
    if (user_type === "U") {
      userPageAccessList = userTypeList[0].route.filter((item) => {
        return item.userRole === role;
      });
      if (userPageAccessList.length > 0) {
        const { includeRoutes, excludeRoutes } = userPageAccessList[0];

        routes = userModuleRoutes?.filter(
          (item) => !excludeRoutes.includes(item)
        );

        routes = routes.concat(includeRoutes);
      }
    } else if (user_type === "CS") {
      routes = userTypeList[0].route;
    } else {
      userPageAccessList = userTypeList[0].route.filter((item) => {
        return item.userRole === role;
      });
      if (userPageAccessList.length > 0) {
        const { includeRoutes, excludeRoutes } = userPageAccessList[0];

        const userDetails = lStorage.get("authInfo");
        if (userDetails.secondary_user_type == "TC") {
          routes = trainerModuleRoutes;
        } else {
          routes = trainerModuleRoutes.filter(
            (item) => !excludeRoutes.includes(item)
          );
        }

        routes = routes.concat(includeRoutes);
      }
    }
  }

  if (routes && isArray(routes)) {
    hasAccess = routes.includes(url);
  } else {
    hasAccess = false;
  }

  return hasAccess;
};
